import type { AttestationFormData } from '@/types/attestation'

/**
 * Props for AttestationScreen component
 * Contains form state and handlers
 */
export interface AttestationScreenBaseProps {
  formData: AttestationFormData
  loading: boolean
  error: string
  onFormDataChange: (updates: Partial<AttestationFormData>) => void
  onSubmit: (e: React.FormEvent) => void
}

/**
 * Default form data for attestation
 */
export const getDefaultFormData = (): AttestationFormData => ({
  attestation_year: 2025,
  individual_income_test: false,
  joint_income_test: false,
  net_worth_test: false,
  country: '',
  market_insights_opt_in: true,
  affirmation: false
})

